<template>

        <!-- <v-select
            prepend-icon="label"
            :items="items"
            :item-text="'tamanio'"
            :item-value="'id'"
            v-model="item"
            :label="$t('producto.labels.tamanio')"
            :loading="loading"
            :error="hasInputErrors('tamanio')"
            :error-messages="getInputErrors('tamanio')"
            color="secondary"
            item-color="secondary"
            :rules="required"
        ></v-select> -->

        <v-autocomplete
            prepend-icon="label"
            :items="items"
            :item-text="'tamanio'"
            :item-value="'id'"
            v-model="item"
            :label="$t('producto.labels.tamanio')"
            :loading="loading"
            :error="hasInputErrors('tamanio')"
            :error-messages="getInputErrors('tamanio')"
            color="secondary"
            item-color="secondary"
            :rules="isRequired ? required : []"
            :multiple="multiple"
            :chips="chips"
            :solo="solo"
            :disabled="disabled"
            :readonly="readonly"
            clearable
            :hide-details="hideDetails"
            :style="{ width: width, maxWidth: width }"
            :return-object="effectiveReturnObject"
        ></v-autocomplete>

</template>

<script>

    import {InputErrorsByProps, RequiredRule} from '@dracul/common-frontend'
    
    
    import TamanioProvider from "../../../../tamanio/providers/TamanioProvider"

    export default {
        name: "TamanioCombobox",
        mixins: [InputErrorsByProps, RequiredRule],
        props:{
            // Puede recibir el objeto completo o el id del tamaño
            value: { type: [Object, String, Array] },
            isRequired: { type: Boolean, default: false },
            multiple: { type: Boolean, default: false },
            solo: { type: Boolean, default: false },
            chips: { type: Boolean, default: false },
            readonly: { type: Boolean, default: false },
            disabled: { type: Boolean, default: false },
            hideDetails: { type: Boolean, default: false },
            returnObject: { type: Boolean, default: false },
            itemValue: { type: String, default: "id" },
            width: { type: String, default: null }
        },
        data() {
            return {
                items: [],
                loading: false
            }
        },
        computed: {
            effectiveReturnObject() {
                if (this.returnObject) return true;
                return this.value != null && typeof this.value === 'object' && !Array.isArray(this.value);
            },
           item: {
                get() { return this.value },
                set(val) {
                    if (val === null || val === undefined || val === '') {
                        this.$emit('input', null);
                        return;
                    }
                    if (typeof val === 'object') {
                        this.$emit('input', val);
                        return;
                    }
                    const foundItems = this.items.filter(item => String(item.id) === String(val));
                    if (foundItems.length > 0) {
                        this.$emit('input', foundItems[0]);
                    }
                }
            }
        },
        mounted() {
         this.fetch()
        },
        methods: {
            validate(){
              return this.$refs.form.validate()
            },
            fetch(){
               this.loading= true
                TamanioProvider.fetchTamanios().then(r => {
                    this.items = r.data.tamanioFetch
                }).catch(err => console.error(err))
                .finally(()=> this.loading = false)
            }
            
        }
    }
</script>

<style scoped>

</style>

